import $ from "jquery";
import { apiError } from "src/shared/model";
import { config } from "src/config/config";
import { store } from "src/store/store";
import { setupXhr } from "../utils";

const handleApiErrors = (jqueryPromise: JQuery.jqXHR): JQuery.Promise<any> => {
  const deferred = $.Deferred<any>();

  jqueryPromise
    .done((data, textStatus, jqXHR) => {
      deferred.resolve(data, textStatus, jqXHR);
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      const status = jqXHR.status;
      if (status === 0 || status === 401 || status >= 500) {
        store.dispatch(apiError(status));
      }
      deferred.reject(jqXHR, textStatus, errorThrown);
    });

  return deferred.promise();
};

export const GetRequest = (
  url: string,
  data?: any,
  headers?: any,
  progress?: any
): JQuery.Promise<any> => {
  return handleApiErrors(
    $.ajax({
      url,
      method: "GET",
      data: data !== "undefined" ? data : {},
      headers: headers !== "undefined" ? headers : {},
      timeout: config.AJAX_GET_TIMEOUT,
      xhrFields: {
        withCredentials: true,
      },
      xhr: function () {
        return setupXhr(progress);
      },
    })
  );
};

export const PatchRequestJson = (
  url: string,
  data: object,
  headers?: any,
  progress?: any
): JQuery.Promise<any> => {
  return handleApiErrors(
    $.ajax({
      url,
      method: "PATCH",
      data: JSON.stringify(data),
      contentType: "application/json;charset=UTF-8",
      headers: headers !== "undefined" ? headers : {},
      timeout: config.AJAX_PATCH_TIMEOUT,
      xhrFields: {
        withCredentials: true,
      },
      xhr: function () {
        return setupXhr(progress);
      },
    })
  );
};

export const PutRequestJson = (
  url: string,
  data: object,
  headers?: any,
  progress?: any
): JQuery.Promise<any> => {
  return handleApiErrors(
    $.ajax({
      url,
      method: "PUT",
      data: JSON.stringify(data),
      contentType: "application/json;charset=UTF-8",
      headers: headers !== "undefined" ? headers : {},
      timeout: config.AJAX_PUT_TIMEOUT,
      xhrFields: {
        withCredentials: true,
      },
      xhr: function () {
        return setupXhr(progress);
      },
    })
  );
};

export const PostRequestJson = (
  url: string,
  data: object,
  headers?: any,
  progress?: any
): JQuery.Promise<any> => {
  return handleApiErrors(
    $.ajax({
      url,
      method: "POST",
      data: JSON.stringify(data),
      // contentType: "application/json;charset=UTF-8",
      contentType: "application/json",
      headers: headers !== "undefined" ? headers : {},
      timeout: config.AJAX_POST_TIMEOUT,
      xhrFields: {
        withCredentials: true,
      },
      xhr: function () {
        return setupXhr(progress);
      },
    })
  );
};

export const DeleteRequest = (url: string, headers?: any) => {
  return handleApiErrors(
    $.ajax({
      url,
      method: "DELETE",
      headers: headers !== "undefined" ? headers : {},
      timeout: config.AJAX_DELETE_TIMEOUT,
      xhrFields: {
        withCredentials: true,
      },
    })
  );
};
